import { Global } from '@emotion/react';
import React from 'react';

export const SetIntercomVisibility = ({ visible }: { visible: boolean }) => {
  const display = `${visible ? 'block' : 'none'} !important`;

  React.useEffect(() => {
    if (typeof window.Intercom !== 'function') return;

    window.Intercom('update', {
      hide_default_launcher: !visible,
    });
  }, [visible]);

  return (
    <Global
      styles={{
        '.intercom-lightweight-app': { display },
        '#intercom-container-body': { display },
      }}
    />
  );
};
